import { render, staticRenderFns } from "./CreateManagerAccount.vue?vue&type=template&id=84ba7860&scoped=true"
import script from "./CreateManagerAccount.vue?vue&type=script&lang=js"
export * from "./CreateManagerAccount.vue?vue&type=script&lang=js"
import style0 from "./CreateManagerAccount.vue?vue&type=style&index=0&id=84ba7860&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84ba7860",
  null
  
)

export default component.exports